<template>
  <div>
    <h3>미션달성형 > 이용자 조회</h3>
    <b-card header="검색 조건">
      <b-form @submit.prevent="submitSearch">
        <b-form-group label-cols="2" horizontal label-class="pull-right"
                      label="캠페인명 ( 코드 네임 )"
                      description="캠페인 종료 후, 최대 30일까지만 조회 가능합니다.">
          <b-select v-model="selectedCampaign" :options="campaignList" text-field="nameWithCodeName">
            <template slot="first">
              <option :value="null" disabled>캠페인을 선택하세요</option>
            </template>
          </b-select>
        </b-form-group>
        <b-form-group label-cols="2" horizontal label-class="pull-right"
                      label="이용자"
                      description="* Game User ID는 대소문자 구분해서 입력해 주세요.">
          <b-row>
            <b-col>
              <b-select v-model="selectedIdType" :options="idTypeSelectList">
                <template slot="first">
                  <option :value="null" disabled>검색 할 아이디 타입을 선택하세요</option>
                </template>
              </b-select>
            </b-col>
            <b-col>
              <b-form-input v-model="idSearchText">
              </b-form-input>
            </b-col>
            <b-col>
              <b-button variant="primary" type="submit" :disabled="isSearching">
                검색 <span v-if="isSearching">중...</span>
              </b-button>
            </b-col>
          </b-row>
        </b-form-group>
      </b-form>

    </b-card>
    <b-card header="검색 결과">
      <div v-if="!isSearching && searchResultInfo && searchResultInfo.length === 0" class="mb-2">
        검색결과가 없습니다.
      </div>
      <b-table :fields="searchResultTableFields" :items="searchResultInfo ? searchResultInfo : []"
               sort-by="createdAt">

        <template slot="campaignDates" slot-scope="data">
          <div>
            {{data.item.mission.startAt}} ~ {{data.item.mission.endAt}}
          </div>
        </template>
      </b-table>
    </b-card>
    <b-card header="상세 로그">
      <b-table :fields="detailLogTableFields" :items="detailLogList">

      </b-table>
    </b-card>
  </div>
</template>

<script>
  import adMasterApi from "@/common/gap/api/adMasterApi.js";
  import missionApi from "@/common/gap/api/missionApi.js";
  import gapmoment from "@/common/gap/util/gapmoment";
  import Mission from "@/common/gap/model/mission";

  export default {
    props: {
      adAccount: null
    },
    data() {
      return {
        selectedCampaign: null,
        campaignList: [],

        campaignNameSelectList: [],

        selectedIdType: null,
        idTypeSelectList: [
          {value: "KAKAO", text: "Account ID - Kakao"},
          {value: "GAME_USER_ID", text: "Game User ID"}
        ],

        idSearchText: "",
        isSearching: false,

        searchResultTableFields: [
          {key: "idpUserId", label: "카카오 Account Id"},
          {key: "gameUserId", label: "Game User ID"},
          {key: "status", label: "상태"},
          {key: "campaignDates", label: "캠페인 집행기간"}
        ],
        searchResultInfo: null,

        detailLogTableFields: [
          //js에서 밀리초까지만 지원해서 마이크로초가 안들어감. .으로 나누기 쉬우므로 밀리초와 마이크로초를 뒤에 붙여줌.
          {key: "createdAt", label: "일시", sortable: true, formatter: (data) => gapmoment.kstToLtz(data, "YYYY-MM-DD HH:mm:ss.") + data.split('.')[1]},
          {key: "logType", label: "로그타입"},
          // {key: "idpType", label: "Idp Type"}, //나중에 다른 Idp 타입이 추가되면 추가
          {key: "idpUserId", label: "카카오 Account Id"},
          {key: "gameUserId", label: "Game User ID"},
          {key: "description", label: "로그 상세"},
        ],
        detailLogList: []
      }
    },
    mounted() {
      this.refreshCampaignList();
    },
    methods: {
      refreshCampaignList() {
        this.selectedCampaign = null;
        if (!this.adAccount)
          return;
        adMasterApi.getCampaigns(this.adAccount.id).then(
            response => {
              const campaignIds =
                  response.data.data
                      .map(elm => elm.id);
              missionApi.getMissionsByCampaignIds(campaignIds).then(
                  response => {
                    this.campaignList = response.data.data.missions
                        .map(elm => {
                          return {
                            nameWithCodeName: `${elm.name} (${elm.codeName})`,
                            value: new Mission(elm)
                          }
                        });
                  }
              );
            }
        );
      },
      submitSearch() {
        if (!this.selectedCampaign) {
          alert("캠페인을 선택하세요");
          return;
        }
        if (!this.idSearchText) {
          alert("검색 값을 입력하세요");
          return;
        }

        if (this.selectedIdType === null) { // 빈값
          alert("아이디 타입을 선택하세요");
          return;
        } else if (this.selectedIdType === "GAME_USER_ID") {     //게임유저아이디
          this.isSearching = true;
          this.searchResultInfo = null;
          this.detailLogList = [];
          missionApi.getLogsByGameUserId(this.selectedCampaign.id, this.idSearchText)
              .then(this.getLogsCallback, this.getLogsErrorCallback);
        } else {    //나머지
          this.isSearching = true;
          this.searchResultInfo = null;
          this.detailLogList = [];
          missionApi.getLogsByIdpUserId(this.selectedCampaign.id, this.selectedIdType, this.idSearchText)
              .then(this.getLogsCallback, this.getLogsErrorCallback);
        }
      },
      getLogsCallback(response) {
        const data = response.data.data;
        this.detailLogList = [];
        this.searchResultInfo = null;
        this.isSearching = false;
        if (!data || (!data.userReward && !data.userRewards)) {
          alert("검색 결과가 없습니다.");
          return;
        }
        this.detailLogList = data.logs;
        this.searchResultInfo = [];
        if (data.userReward) { //단일 결과 (게임 아이디로 검색)
          if (data.userReward.gameUserId) {
            this.searchResultInfo = [data.userReward];
          }
        } else if (data.userRewards) { //리스트 결과 ( 카카오 아이디로 검색)
          this.searchResultInfo = data.userRewards;
        } else {
          return;
        }

        for (const info of this.searchResultInfo) {
          info.mission = new Mission(info.mission);
        }
      },
      getLogsErrorCallback(error) {
        this.isSearching = false;
        console.log(error.response.status);
      }
    },
    watch: {
      adAccount: {
        handler(newVal, oldVal) {
          this.refreshCampaignList();
        },
        deep: true
      }
    }
  }
</script>

<style>

</style>
